export enum GetterTypes {
  COMPANY_GET_WIZARD = "COMPANY_GET_WIZARD",
  COMPANY_GET_COMPANY = "COMPANY_GET_COMPANY"
}
